/**
 *
 */
export const isChildCropped = (parent: HTMLElement, child: HTMLElement) => {
  if (parent == null || child == null) {
    return false;
  }

  const parentRect = parent.getBoundingClientRect();
  const childRect = child.getBoundingClientRect();

  // Check if the child extends beyond any of the parent's four edges
  const isOverflowing =
    childRect.top < parentRect.top ||
    childRect.bottom > parentRect.bottom ||
    childRect.left < parentRect.left ||
    childRect.right > parentRect.right;

  // Get the parent's computed overflow style
  const parentStyle = window.getComputedStyle(parent);
  const isParentClipping =
    parentStyle.overflow === 'hidden' || parentStyle.overflowX === 'hidden' || parentStyle.overflowY === 'hidden';

  // It's only truly "cropped" if it overflows AND the parent clips it
  return isOverflowing && isParentClipping;
};
